//Data service is for sharing data betwwen components
import { Injectable } from '@angular/core';
import { CustomerProfile } from '../security/models/customer-profile.model';

@Injectable()
export class DataService {
  sharedData: any;
  custProfile: CustomerProfile;
  

  setSharedData(data){
    this.sharedData = data;
  }

  getSharedData(): any{
    return this.sharedData;
  }

  setCustomerProfile(customer: CustomerProfile){
    this.custProfile = customer;
  }

  getCustomerProfile(): CustomerProfile{
    return this.custProfile;
  }

  clearData(){
    this.sharedData = null;
    this.custProfile = null;
  }
  
}